import { render, staticRenderFns } from "./msw-licensestatus-widget.vue?vue&type=template&id=1b9310be&"
import script from "./msw-licensestatus-widget.vue?vue&type=script&lang=tsx&"
export * from "./msw-licensestatus-widget.vue?vue&type=script&lang=tsx&"
import style0 from "./msw-licensestatus-widget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports